import gql from "graphql-tag";

export class HealthyNutritionManager {
    constructor(
        apolloMobileClient,
    ) {
        this._apolloMobileClient = apolloMobileClient;
    }

    async getHealthyNutritionWeek (patientId, planningDateMoment) {
        return this._apolloMobileClient
            .query({
                query: gql`query myHealthyNutritionWeek(
                    $patientId: Int!
                    $planningDate : Date!
                ) {
                      myHealthyNutritionWeek(
                          planningDate: $planningDate
                          patientId : $patientId
                      ) {
                        isCompleted
                        score
                        scoreAsPercent 
                        wasInActionStage
                        startDate
                        endDate
                        allAnswersGivenInWeek

                        planning {
                          startDate
                          wasInActionStage
                        }
                        
                        achievedGoals {
                          key
                          foodGroupKey
                          answer
                          answerLabel
                          hasPatientGoals
                          goal {
                            id
                            name
                            frequencyLabel
                            typeLabel
                            unitLabel
                            foodGroup {
                              key
                              label
                              unitLabel
                              ranges{
                                label
                              }
                            }
                          }
                        }
                      }
                }`, variables: {
                    patientId : parseInt(patientId),
                    planningDate : planningDateMoment.format("YYYY-MM-DD")
                }
            }).then(result => {
                return result.data.myHealthyNutritionWeek
            })
    }

    async getHealthyNutritionGoals () {
        return this._apolloMobileClient
          .query({
              query: gql`{
                healthyNutritionGoals{
                  name
                  id
                  foodGroup {
                    key
                    unitLabel
                    
                    ranges {
                      label
                    }
                  }
                  associatedEProQuestion {
                      answerSet{
                        answers{
                          score
                          key
                          text
                        }
                      }
                    }
                }
              }`
          }).then(result => {
              return result.data.healthyNutritionGoals
          })
    }

  async getHealthyNutritionWeeks (patientId, planningStartDateMoment, planningEndDateMoment) {
    return this._apolloMobileClient
      .query({
        query: gql`query myHealthyNutritionWeeks($patientId: String!, $planningStartDate: String!, $planningEndDate: String!) {
                      myHealthyNutritionWeeks(
                            functions : [{function : patientId, parameters : [$patientId]}]
                            conditions : {field : planningStartDate, operator: between_day, parameters : [$planningStartDate, $planningEndDate]}
                            orders : [{field : planningStartDate, direction : asc}]
                      ) {
                        edges {
                          node {
                            startDate
                            
                            planning {
                              startDate
                              wasInActionStage
                            }
                            
                            id
                            isCompleted
                            score
                            scoreAsPercent
                            wasInActionStage
                            allAnswersGivenInWeek
                            
                            achievedGoals {
                              score
                              key
                              foodGroupKey
                              answer
                              answerLabel
                              hasPatientGoals
                              goal {
                                id
                                name
                                frequencyLabel
                                typeLabel
                                unitLabel
                                foodGroup {
                                  key
                                  label
                                  unitLabel
                                  ranges {
                                    label
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                    `, variables: {
                        patientId : patientId.toString(),
                        planningStartDate : planningStartDateMoment.format("YYYY-MM-DD"),
                        planningEndDate : planningEndDateMoment.format("YYYY-MM-DD")
                    }
      }).then(result => {
        return result.data.myHealthyNutritionWeeks
      })
  }
}
